import { Module, useWorkspaceBillingQuota } from '@/composables/billing/useWorkspaceBillingQuota';

export default function quotaAlert(): void {
  void useWorkspaceBillingQuota(Module.CONVERSATION).fetchQuota();
}
